import client from '../../providers/fetchClient'

export const fetchAllEmployees = params => client.get('/v3/employees', { params })

export const createEmployee = data => client.post('/v3/employees', data)

export const deleteEmployee = id => client.delete(`/v3/employees/${id}`)

export const updateEmployee = (data, id) => client.put(`/v3/employees/${id}`, data)
